import { CollectionService } from './index';

const TraitSnpService = CollectionService('/trait-snps');

export default TraitSnpService;
